<template>
  <b-container
    tag="section"
    class="settings-cont plan-subscription">
    <b-row>
      <b-col
        sm="12"
        md="10"
        lg="8"
        offset-md="1"
        offset-lg="2"
        class="mb-5">
        <img
          class="sendbee-logo"
          src="~@/assets/img/SB-Images/app-logo.svg"
          alt="AI Number" >
        <h2>
          Unable to activate your subscription.
        </h2>
        <span class="description">Please contact AI Number for further assistance.</span>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import '@/assets/css/modules/_settings.scss';

export default {
  name: 'NoPlanSubscription',
};
</script>
